/**
* All rights Reserved, Designed By www.feidai.com
* @Title: login.ts
* @Package:
* @author: 青瞳科技
* @date: 2025/12/01 16:53:37
* @version: V1.0
* @Copyright: 2019 www.feidai.com Inc. All rights reserved.
* @Belong To: 青瞳科技
* 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
*/
const loginRouter = [
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/index.vue"
      ),
    meta: {
      title: "登录",
      keepAlive: true,
      deepth: 1,
    },
  },
  {
    path: "/pwdLogin",
    name: "PwdLogin",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/pwdLogin.vue"
      ),
    meta: {
      title: "密码登录",
      keepAlive: true,
      deepth: 2,
    },
  },
  {
    path: "/findPwd",
    name: "FindPwd",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/findPwd.vue"
      ),
    meta: {
      title: "找回密码",
      keepAlive: true,
      deepth: 3,
    },
  },
  {
    path: "/resetPwd",
    name: "ResetPwd",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/views/login/resetPwd.vue"
      ),
    meta: {
      title: "重置密码",
      keepAlive: true,
      deepth: 4,
    },
  },
];

export default loginRouter;
